import React from 'react'
import { motion } from 'framer-motion'

const Contact = () => {
  return (
    <div className="container-fluid p-5 white-color black-bg" id='contact'>
      <div className="container card shadow p-4 rounded-4 offer-card text-center border-0">
        <h1>Prêt à Transformer Votre Présence en Ligne ?</h1>
        <p>Ne laissez pas votre business passer inaperçu. Un site web, c’est votre vitrine digitale !</p>
        <h3>Passez à l’action dès maintenant.</h3>
        <div className="d-flex justify-content-center">
        <motion.button
            className="btn btn-light rounded-pill px-4 py-2"
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
          >
            <a className="text-decoration-none blue-color" href="https://tally.so/r/m6vN5o" target='blank'>
            Obtenez un devis en 24h
            </a>
          </motion.button>
        </div>
      </div>
    </div>
  )
}

export default Contact
